import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { User } from '../../users/_types/user';
import { LocalStorageService } from 'angular-web-storage';
import { CaseService } from '../../cases/_types/case-service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { CasesServicesService } from '../../cases/_services/cases-services.service';
import { AndFilter, Filter, FilterOperation, NotFilter, OrFilter } from 'src/app/core/jsonapi/filter';
import moment from 'moment';
import { WorkersService } from '../../workers/_services/workers.service';
import { Worker } from '../../workers/_types/worker';
import { DatePipe } from '@angular/common';
import { ChatService } from '../../chat/_services/chat.service';
import { UsersService } from '../../users/_services/users.service';
import { ContractProcessorsService } from '../../companies/_services/contracts-processors.service';
import { CasesService } from '../../cases/_services/cases.service';
import { LoginService } from '../../login/login.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { PhoneService } from '../../phone/_services/phone.service';
import { ComunicationsComponent } from '../../comunications/communications/comunications.component';
import { DialogService } from 'primeng/dynamicdialog';
import { WhatsAppChatComponent } from '../../whatsapp/chat/whatsapp-chat.component';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-processor',
    templateUrl: './processor.component.html',
    styleUrls: ['./processor.component.css'],
    standalone: false
})
export class ProcessorComponent implements OnInit, OnDestroy {
  public loadingServices: boolean = false;
  public caseServices: CaseService[] = [];
  public totalServicesRecords: number = 0;
  public allowWriteService: boolean = false;
  public allowDeleteService: boolean = false;
  public user!: User;
  public now: Date = new Date();
  public nowMinus20Minutes: Date = new Date(new Date().getTime() - 20 * 60000);
  private lastGridEvent: any;
  public filters: any = {
    workerId: new Filter(FilterOperation.equals, 'workerId'),
    isConfirmed: new Filter(FilterOperation.equals, 'isConfirmed', '', true),
    isCancelled: new Filter(FilterOperation.equals, 'isCancelled', '', false),
    processorId: new Filter(FilterOperation.equals, 'processorId')
  };
  public totals: any ={
    OnTime: 0,
    TooLate: 0,
    Started: 0,
    Ended: 0,
    Rejected: 0,
    Failed: 0,
    Total: 0
  };
  public states: Array<any> = [
    { name: 'En tiempo', id: 'on_time' },
    { name: 'Llega tarde', id: 'too_late' },
    { name: 'Iniciada', id: 'started' },
    { name: 'Finalizada', id: 'ended' },
    { name: 'Rechazada', id: 'rejected' },
    { name: 'Fallida', id: 'failed' }
  ];

  public searchParams: any = {};
  public workers: Array<Worker> = new Array<Worker>();
  public date: Date | null = null;
  public processors: Array<User> = new Array<User>();
  private loadServicesTimeout: ReturnType<typeof setTimeout> | null = null;
  public processorContractIds: string[] = [];

  
  public allowAssignProcessor: boolean = false;
  public displayProcessorModal: boolean = false;
  public selectedCases: string[] = [];
  public selectedCaseIds: string[] = []; //Los ids seleccionados
  public processorId: string = "";

   //panel de opciones de telefono
  @ViewChild('phoneOverlayPanel') public phoneOverlayPanel?:OverlayPanel;
  public phoneOverlayPanelData: {
    phoneNumber?: string;
    callerId?: string;
    caseService?: CaseService;
    caseId?: string;
    caseServiceId?: string;
  } = {
    phoneNumber: undefined,
    callerId: undefined,
    caseService: undefined,
    caseId: undefined,
    caseServiceId: undefined
  };


  constructor(
    private loginService: LoginService,
    private topbarService: TopbarService,
    private storage: LocalStorageService,
    private casesServicesService: CasesServicesService,
    private workersService: WorkersService,
    private chatService: ChatService,
    private usersService: UsersService,
    private contractProcessorsService: ContractProcessorsService,
    private casesService: CasesService,    
    private phoneService: PhoneService,
    private dialogService: DialogService,
    private messageService: MessageService
  ) {
    this.topbarService.setTitle('Dashboard');
    this.date = new Date();
    this.allowAssignProcessor =  this.loginService.hasPermission("CASES.ASSIGN_PROCESSOR");
  }

  async ngOnInit(): Promise<void> {
    this.user = this.storage.get('user');
    this.searchParams.processorId = this.user.id;
    //this.loadServices();
    this.allowWriteService = true; //this.loginService.hasPermission("SERVICES_WRITE");
    this.allowDeleteService = true; //this.loginService.hasPermission("SERVICS_DELETE");
    this.loadWorkers();
    await this.loadProcessorContracts();
    this.loadProcessors();
  }

  async loadProcessorContracts(){
    
    let filter: any = {
      processorId: new Filter(FilterOperation.equals, 'processorId', '', this.user.id)
    };
    let params:IParamsCollection = {
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.contractProcessorsService.all(params));
    const processorContracts = response.data;
    this.processorContractIds = processorContracts.map(pc => pc.contractId);
  }

  ngOnDestroy(): void {
    if (this.loadServicesTimeout) {
      clearTimeout(this.loadServicesTimeout);
    }
  }

  async loadServices($event: any) {
    this.nowMinus20Minutes = new Date(new Date().getTime() - 20 * 60000);
    this.loadingServices = true;
    this.lastGridEvent = $event;
    this.now = new Date();

    let params: IParamsCollection = {
      page: { number: /*$event.first +*/ 1, size: 1000/*$event.rows*/ },
      include: ['worker','case.company', 'case.client','case.client.address', 'case.processor', 'materials.material'],
      sort: ['date']
    };

    let startDate = moment(this.date).startOf('day');
    let endDate = moment(this.date).endOf('day');
   
    this.filters.date1 = new Filter(FilterOperation.greaterThan,'date','',startDate.toISOString());
    this.filters.date2 = new Filter(FilterOperation.lessThan,'date','', endDate.toISOString());

    this.filters.name = new Filter(FilterOperation.contains, 'case.reference', '', this.searchParams.name, false);
    this.filters.name2 = new Filter(FilterOperation.contains, 'case.caseNumber', '', this.searchParams.name, false);
    this.filters.name3 = new Filter(FilterOperation.contains, 'case.client.name', '', this.searchParams.name, false);
    
    if(this.searchParams.workerId) {
      this.filters.workerId = new Filter(FilterOperation.equals,'workerId','',this.searchParams.workerId);
    }else{
      delete this.filters.workerId;
    }
    
    if(this.searchParams.processorId) {
      this.filters.processorId = new Filter(FilterOperation.equals,'case.processorId','',this.searchParams.processorId);
    }else{
      if(this.loginService.hasPermission('CASES.VIEW_ALL_CASES')){
        delete this.filters.processorId;
      }else{

        //los mios o los que estan en mis contratos y estan ausentes.
        this.filters['processorId'] =new OrFilter([
                  new Filter(FilterOperation.equals, 'case.processorId', '', this.user.id),
                  new Filter(FilterOperation.equals, 'case.contract.responsibleUserId', '', this.user.id),
                  new Filter(FilterOperation.equals, 'case.contract.secondResponsibleUserId', '', this.user.id),
                  new AndFilter([
                    new Filter(FilterOperation.equals, 'case.processor.absence', '', true),
                    new Filter(FilterOperation.any, 'case.contractId', '', (this.processorContractIds.length>0?this.processorContractIds:null))
                  ])
              ]);

      }
      
    }

    if(this.searchParams.dateEnd){
      this.filters.dateEnd = new NotFilter(FilterOperation.equals, 'dateEnd', '', null, true);
    }else{
      delete this.filters.dateEnd
    }

    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.casesServicesService.all(params));
     //contamos cuantas de cada tipo
    this.totals = {
      OnTime: response.data.filter((cs) => this.isOnTime(cs)).length,
      TooLate: response.data.filter((cs) => this.isTooLate(cs)).length,
      Started: response.data.filter((cs) => this.isStarted(cs)).length,
      Ended: response.data.filter((cs) => this.isEnded(cs)).length,
      Rejected: response.data.filter((cs) => this.isRejected(cs)).length,
      Failed: response.data.filter((cs) => this.isFailed(cs)).length,
      Total: response.data.length
    };
  
    if(this.searchParams.stateId){
      switch(this.searchParams.stateId){
        case 'on_time':
          this.caseServices = response.data.filter((cs) => this.isOnTime(cs));
          break;
        case 'too_late':
          this.caseServices = response.data.filter((cs) => this.isTooLate(cs));
          break;
        case 'started':
          this.caseServices = response.data.filter((cs) => this.isStarted(cs));
          break;
        case 'ended':
          this.caseServices = response.data.filter((cs) => this.isEnded(cs));
          break;
        case 'rejected':
          this.caseServices = response.data.filter((cs) => this.isRejected(cs));
          break;
        case 'failed':
          this.caseServices = response.data.filter((cs) => this.isFailed(cs));
          break;
      }
    }else{
      this.caseServices = response.data;
    }
    this.totalServicesRecords = response.meta['total'];
    this.loadingServices = false;

   

    if(this.loadServicesTimeout!=null) clearTimeout(this.loadServicesTimeout);
    this.loadServicesTimeout = setTimeout(() => {
      this.loadServices($event);
    }, 60 * 1000);
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadServices(this.lastGridEvent);
    
  }

  isOnTime(service:CaseService):boolean{
    return !service.isFailed && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.date>this.nowMinus20Minutes && service.dateStart==null;
  }

  isTooLate(service:CaseService):boolean{
    //console.log(this.nowMinus20Minutes);
    return !service.isFailed && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.date<this.nowMinus20Minutes && service.dateStart==null;
  }

  isStarted(service:CaseService):boolean{
    return !service.isFailed && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.dateStart!=null && service.dateEnd==null;
  }

  isEnded(service:CaseService):boolean{
    return !service.isFailed && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.dateStart!=null && service.dateEnd!=null;
  }

  isRejected(service:CaseService):boolean{
    return service.workerAttendanceStatus=='rejected' || service.workerAttendanceStatus=='rejected_day';
  }

  isFailed(service:CaseService):boolean{
    return service.isFailed && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day';
  }

  async loadProcessors(){
    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 1000 }
    };

    // filtrar solo tramitadores
    let filters: any = {
      userType: new OrFilter([
        new Filter(FilterOperation.equals, 'userType.code', '', 'processor'),
        new Filter(FilterOperation.equals, 'id', '', this.user.id)
      ]),
      id: new Filter(FilterOperation.any, 'id', '')
    };

    //lista de tramitadores. Irán filtrados por su permiso
    if(this.loginService.hasPermission('CASES.VIEW_ALL_CASES')){
      //creamos filtros
      params.filter = FilterBuilder.fromObject(filters).build();  
      let response = await firstValueFrom(this.usersService.all(params));
      this.processors = response.data;
    }else{
      //obtienes los contratos donde el usuario es tramitador.
      let filters2 = {
        processorId: new Filter(FilterOperation.equals, 'processorId', "", this.user.id)
      };  
      let params2: IParamsCollection = { page: { number: 1, size: 2000}}
      //creamos filtros
      params2.filter = FilterBuilder.fromObject(filters2).build();
      var contractProcessors = await firstValueFrom(this.contractProcessorsService.all(params2)).then(response => response.data);
      var contractsIds = contractProcessors.filter((v, i, a) => a.findIndex(t => (t.contractId === v.contractId)) === i).map(cp => cp.contractId);

      //los tramitadores de los mismos contratos que el usuario
      let filtersCases = {
        contractId: new Filter(FilterOperation.any, 'contractId', "", contractsIds)        
      };  
      let paramsCases: IParamsCollection = { page: { number: 1, size: 2000}}
      //creamos filtros
      paramsCases.filter = FilterBuilder.fromObject(filtersCases).build();
      var contractProcessorsAll = await firstValueFrom(this.contractProcessorsService.all(paramsCases)).then(response => response.data);
      var contractProcessorsAllIds = contractProcessorsAll.filter((v, i, a) => a.findIndex(t => (t.processorId === v.processorId)) === i).map(cp => cp.processorId);

      //añadimos a el mismo
      contractProcessorsAllIds.push(this.user.id!);

      //filtramos por los usuarios que forman parte de los mismos contratos que el usuario logueado.
      filters.id = new Filter(FilterOperation.any, 'id', '', contractProcessorsAllIds);
      params.filter = FilterBuilder.fromObject(filters).build();  
      let response = await firstValueFrom(this.usersService.all(params));
      this.processors = response.data;

    }
  }

  async loadWorkers() {
    let response = await firstValueFrom(this.workersService.all());
    this.workers = response.data;
  }

  async openChat(service: CaseService) {
    let titleParts: string[] = [];
    if (service.case) titleParts.push(service.case.caseNumber);
    let datePipe = new DatePipe('es-ES');
    titleParts.push('Cita ' + datePipe.transform(service.date, 'dd/MM/yyyy')!);
    if (service.worker) titleParts.push(service.worker.name);
    let title = titleParts.join(" - ");
    this.chatService.openChatCaseService(service, title);
  }


  async prevDate(){
    this.date = moment(this.date).subtract(1, 'day').toDate();
    this.search();
  }

  async nextDate(){
    this.date = moment(this.date).add(1, 'day').toDate();
    this.search();
  }


  showPhoneOverlayPanel($event:any, phoneNumber:string|undefined, callerId:string|undefined, caseService:CaseService|undefined = undefined, caseid: string|undefined = undefined){
    //si no hay caseService, buscamos el siguiente que lo toca en la lista
    if(caseService == undefined){
      console.log("No case service especified, searching for next caseservice");
      //ordenamos por fecha
      let orderedCaseServices = this.caseServices.sort((a: CaseService, b: CaseService) => {
        return a.date.getTime() - b.date.getTime();
      });
      //buscamos el siguiente
      caseService = orderedCaseServices.find((service: CaseService) => {
        return service.date >= new Date();
      });
    }

    this.phoneOverlayPanelData.caseService = caseService;
    this.phoneOverlayPanelData.phoneNumber = phoneNumber;
    this.phoneOverlayPanelData.callerId = callerId;
    this.phoneOverlayPanelData.caseId = caseid;
    this.phoneOverlayPanel?.show($event);
  }

  
  
    openWhatsapp(caseId:string|null = null, phoneNumber:string, name:string|null){
      //abrimos dialogo de whatsapp
      let ref = this.dialogService.open(WhatsAppChatComponent, {
        closable: true,
        modal: true,
        header: 'Whatsapp ' + phoneNumber + (name ? ' - ' + name : ''),
        width: '800px',
        draggable: true,
        data: {
          caseId: caseId,
          phoneNumber: phoneNumber,
          name: name
        }
      });
      ref.onClose.subscribe((data: any) => {
        //nothing to do
      });
    }

    addComunication(comunicationType:string|null, email:string|null, phoneNumber:string|null, attachment: boolean = false) {
      let comunicationModel:any = this.phoneOverlayPanelData.caseId;
      comunicationModel.caseService = this.phoneOverlayPanelData.caseService;
      let ref = this.dialogService.open(ComunicationsComponent, {
        closable: true,
        modal: true,
        header: 'Enviar comunicación',
        width: '60%',
        draggable: true,
        data: {
          caseId: this.phoneOverlayPanelData.caseId,
          model: comunicationModel,
          comunicationType: comunicationType,
          email: email,
          phoneNumber: phoneNumber,
          templateDestination: 'Case',
         // attachments: (attachment ? this.filesIdsToSend: [])
        }
      });
  
      ref.onClose.subscribe((data: any) => {
       // this.loadLogs(this.lastGridLogEvent);
      });
    }

  sms(phoneNumber:string|undefined, caseId:string|null = null, caseServiceId:string|null = null){
    if(phoneNumber){
     this.addComunication('SMS', null, phoneNumber);
     this.phoneOverlayPanel?.hide();
    }
  }

  whatsapp(phoneNumber:string|undefined, caseId:string|null = null, callerId:string|null = null){
    if(phoneNumber){
     //this.addComunication('Whatsapp', null, phoneNumber);
     this.openWhatsapp(caseId, phoneNumber, callerId);
     this.phoneOverlayPanel?.hide();
    }
  }

  call(phoneNumber:string|undefined, callerId:string|null = null, caseId:string|null = null, caseServiceId:string|null = null){
     if(phoneNumber){
      this.phoneService.call(phoneNumber!, callerId, true, caseId, caseServiceId);
      this.phoneOverlayPanel?.hide();
     }
  }

  private getCurrentCaseServiceIds(): string[] {
    return Array.from(new Set(this.caseServices.map(service => service.caseId).filter((id): id is string => !!id)));
  }

  private getUniqueIds(ids: string[]): string[] {
    return Array.from(new Set(ids));
  }

  isAllCaseServicesSelected(): boolean {
    const currentCaseIds = this.getCurrentCaseServiceIds();
    return currentCaseIds.length > 0 && currentCaseIds.every(id => this.selectedCases.includes(id));
  }

  toggleAllCaseServicesSelection(checked: boolean): void {
    const currentCaseIds = this.getCurrentCaseServiceIds();

    if (checked) {
      this.selectedCases = this.getUniqueIds([...this.selectedCases, ...currentCaseIds]);
      return;
    }

    this.selectedCases = this.selectedCases.filter(id => !currentCaseIds.includes(id));
  }

  assignProcessor() {
    this.selectedCaseIds = this.getUniqueIds(this.selectedCases);

    if (this.selectedCaseIds.length > 0) {
      this.loadProcessors();
      this.displayProcessorModal = true;
    } else {
      this.messageService.add({ closable: true, severity: 'error', detail: "Debe seleccionar al menos un expediente" });
    }
  }

  async saveProcessor() {
    await firstValueFrom(this.casesService.updateProcessor(this.processorId!, this.selectedCaseIds));
    this.displayProcessorModal = false;
    this.selectedCases = [];
    this.selectedCaseIds = [];
    //recargamos los tres porque pueden concidir en expediente en las tres tablas
    this.loadServices(this.lastGridEvent);
  }
  
}
